module.exports = __webpack_public_path__ + "img/timer-stopwatch-black.acd24cd4.svg";